import { defineStore } from "pinia";

import modelClass from "@models/contact";
import * as getters from "@modelStores/helpers/getters-helper";

export const useContactStore = defineStore("contact-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
